export const SHOW_ALERT = 'SHOW_ALERT';
export const DISSMISS_ALERT = 'DISSMISS_ALERT';

export function showAlert(data) {
  return {
    type: SHOW_ALERT,
    payload: data,
  }
}

export function dissmissAlert() {
  return {
    type: DISSMISS_ALERT,
    payload: {
      title: null,
      message: null,
      status: null,
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/alert/index.js